import * as authHandler from "./auth.jsx";
import * as appHandler from "./app.jsx";
import * as fsHandler from "./fs.jsx";
import * as userHandler from "./user.jsx";
import * as sdHandler from "./sd.jsx";

export default {
  ...authHandler,
  ...appHandler,
  ...fsHandler,
  ...userHandler,
  ...sdHandler,
};
